<style>
  .el-collapse-item__header {
      padding-left: 15px;
  }
  .el-upload--picture-card {
    float: left;
    margin-right: 10px;
} 
  .circle-closesty {
      position: relative;
    top: -35px;
    margin-left: 112px;
    font-size: 20px;
    cursor: pointer;
  }
  .v-modal {
    z-index: 100 !important;
  }
  .ipt-sty {
    width: 70% !important;
  }
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="7" >
        <div class="search-area-div">月份:</div>
          <el-date-picker
            v-model="page.month"
            type="month"
            class="ipt-sty"
            placeholder="选择月">
          </el-date-picker> 
          </el-col>   
          <!-- <el-input v-model="page.staffName" class="ipt-sty" placeholder="请输入人员"></el-input>-->
          <el-col  :span="6" class="t-left"> 
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
          </el-row> 
    </div>   
    <div class=" back-color-fff p16 pt2 mt15">
    <div class="content-text mb15">
              <img width="25" class="fl" src="../../assets/images/remind1.png">
              <p>在缴员工参保明细展示的为单位实际在保人员情况，每月26日提供</p>
      </div>  
      <el-table :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))" border style="width: 100%" :height="height" v-loading="tableLoading"> 
      <el-table-column label="序号" header-align="center" align="center" width="115"> 
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="输入参保人"/>
          </template>
          <template slot-scope="scope"> 
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="参保人" header-align="center" align="center"> 
          <template slot-scope="scope">{{ scope.row.name}}</template>
          </el-table-column> 
          <el-table-column prop="organisationNames" label="组织" header-align="center" align="center"> 
          <template slot-scope="scope">{{ scope.row.organisationNames | roleNames}}</template>
          </el-table-column>
          <el-table-column prop="positionNames" label="岗位" header-align="center" align="center"> 
          <template slot-scope="scope">{{ scope.row.positionNames | roleNames}}</template>
          </el-table-column>
        <el-table-column prop="type" label="状态" header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.type}}</template>
        </el-table-column> 
        <el-table-column prop="positionNames" label="社保" header-align="center" align="center"> 
              <el-table-column prop="insErAmount" label="单位缴纳" header-align="center" align="center"></el-table-column>
              <el-table-column prop="insEeAmount" label="个人缴纳" header-align="center" align="center"></el-table-column>
              <el-table-column prop="insAmount" label="合计" header-align="center" align="center"></el-table-column>
        </el-table-column> 
        <el-table-column prop="positionNames" label="公积金" header-align="center" align="center"> 
              <el-table-column prop="fundErAmount" label="单位缴纳" header-align="center" align="center"></el-table-column>
              <el-table-column prop="fundEeAmount" label="个人缴纳" header-align="center" align="center"></el-table-column>
              <el-table-column prop="fundAmount" label="合计" header-align="center" align="center"></el-table-column>
        </el-table-column> 
        <el-table-column prop="otherFee" label="其他" header-align="center" align="center"></el-table-column>
        <el-table-column prop="allErAmount" label="单位合计" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="allEeAmount" label="个人合计" header-align="center" align="center"> 
        </el-table-column> 
        <el-table-column label="操作" header-align="center" align="center" fixed='right'> 
          <template slot-scope="scope">
            <a class="txt-color" @click="toLink(scope.row.idCard)">详情</a> 
          </template>
        </el-table-column>
      </el-table> 
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>   
  </div>
</template>

<script> 
import {route}  from '@/api/apiRoute';
import store from '@/store'
export default {
  data() {
    return { 
      tableData:[], 
      page: {
        pageIndex: 1,
        pageSize: 200,
        totalPage: 0,
        totalRows: 0,
        month:'',
      },    
      search: '',
      tableLoading:false,
      winHeight: window.innerHeight, 
      height:window.innerHeight - 340,
    };
  },
  created() {
    // 列表
    this.getData(false); 
    // this.getTenant();
    // this.getTenantDz();
    // this.getCurrentManageStaff();
  }, 
  mounted() {
    // this.selectMenu = this.$route.path;
    // window.onresize = () => {
    //   return () => {
    //     this.winHeight = window.innerHeight;
    //   };
    // };
    // this.height = this.winHeight - 340;
    // console.log(this.height,this.winHeight-340);
  },
  methods: { 
    empty() {
      let self = this;
      self.timeList = '';
      self.timeListS = '';
      self.page = {
        pageIndex: 1,
        pageSize: 200,
        totalPage: 0,
        totalRows: 0,
        month:'',
      };
      self.getData(true); 
    }, 
    getData(flg) {
      let self = this;
      if(self.page.month == '' || self.page.month == null){
           var date = new Date(),
            year = date.getFullYear(),
            month = date.getMonth() + 1;
            if (month < 10) {
              month = "0" + month;
            } 
            var time = year + "-" + month; 
            self.page.month = time; 
      }else{
         self.page.month = self.$moment(self.page.month).format('YYYY-MM');
      }
      // self.page.performanceGuid = self.$router.history.current.query.guid;
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msUserRemunerationService}/sb51/get-insurance-bill-list?billDate=`+self.page.month+'&page=1').then(res => { 
        self.tableLoading = false;
        if (res.data.data.result.list != null) {  
          self.tableData = res.data.data.result.list; 
          self.page.totalRows = res.data.data.result.total_num;
          console.log(self.tableData);
        } else { 
          self.$message.error(res.data.data.message);
        }
      });
    }, 
    toLink(idCard){
             this.$router.push({path: "/insuredDetail", query:{   productGuid:this.$route.query.productGuid,idCard:idCard,month:this.page.month}})
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
     height: 40px; 
     line-height: 40px; 
}
.el-range-editor.el-input__inner { 
     padding: 0px; 
}
/deep/ .el-checkbox__label {
    display: none;
}
.attach-sty {
    width: 170px;
    float: left; 
    margin-top: 15px;
    text-align: center;
}
.checkbox-img-sty {
    border: 1px solid #DCDFE6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
}
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
</style>